import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// Importă Tailwind CSS
import './assets/tailwind.css'

// Importă componentul web
import '@stoplight/elements/web-components.min.js'

const app = createApp(App)

// Folosește router-ul
app.use(router)

app.mount('#app')
